export default "__VITE_ASSET__DOws5O_D__"